import { APIResponse } from "./api-response.type";
import { StatusValues } from "./common.types";

export enum PlanInterval {
  WEEKLY = 'week',
  MONTHLY = 'month',
  YEARLY = 'year',
  QUARTERLY = 'quarter',
}

/** How a plan's price is described, per billing interval. */
export const priceLabels: Record<PlanInterval, string> = {
  [PlanInterval.WEEKLY]: 'Weekly Price',
  [PlanInterval.MONTHLY]: 'Monthly Price',
  [PlanInterval.QUARTERLY]: 'Quarterly Price',
  [PlanInterval.YEARLY]: 'Yearly Price',
};

/** How a plan's token budget is described, per billing interval. */
export const tokenLimitLabels: Record<PlanInterval, string> = {
  [PlanInterval.WEEKLY]: 'Weekly Token Limit',
  [PlanInterval.MONTHLY]: 'Monthly Token Limit',
  [PlanInterval.QUARTERLY]: 'Quarterly Token Limit',
  [PlanInterval.YEARLY]: 'Yearly Token Limit',
};

export type AiModel = {
  _id?: string;
  platform: string;
  modelName: string;
  inputTokens?: number;
  outputTokens?: number;
}

export type AiPlan = {
  _id: string;
  name: string;
  description: string;
  content?: string;
  /** Recurring price for one `planInterval`. 0 = free plan. */
  price: number;
  planInterval: PlanInterval;
  aiModels: AiModel[];
  allowedModels: string[];
  tokenLimit?: number;
  /** @deprecated pre-rename name for `tokenLimit`; read only to prefill the form. */
  monthlyTokenLimit?: number;
  status: StatusValues;
  createdAt: string;
  updatedAt: string;
}

export type CreatePlanInput = {
  id?: string;
  name: string;
  description: string;
  content?: string;
  price: number;
  planInterval: PlanInterval;
  aiModels: AiModel[];
  allowedModels: string[];
  tokenLimit: number;
  status: StatusValues;
}

export interface CreatePlanResponse extends APIResponse {
  data: {
    plan: AiPlan,
  } |  null,
}

export interface PlansResponse extends APIResponse {
  data: {
    plans: AiPlan[],
  } |  null,
}

export interface PlanResponse extends APIResponse {
  data: {
    plan: AiPlan,
  } |  null,
}